import useServiceReveal from '../../hooks/useServiceReveal';
// export default HealthSubService;
import React, { useEffect, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { serviceDetailData } from "../../constants/data";
import useTranslate from "../../hooks/useTranslate";
import "./HealthSubService.scss";
import Navbar from "../../components/Navbar/MainNavbar/Navbar";
import Footer from "../../components/Footer/Footer";
import Image1 from "../../img/kavak-members/0002.jpg";
import ServiceProjects from '../ServiceDetail/ServiceProjects';

const HealthSubService = () => {
  const { subServiceSlug, deptSlug } = useParams(); // ← اضافه شد deptSlug
  const navigate = useNavigate();
  const { translate, language } = useTranslate();
  const isRTL = language === "fa";

  // ← کلید اصلی: اگه deptSlug هست، دیتا رو از اون بخون
  const activeSlug = deptSlug || subServiceSlug;
  const detail = serviceDetailData[activeSlug];
  const revealRoot = useRef(null);
  useServiceReveal(revealRoot, `${activeSlug}-${language}`);

  // ← Scroll to top وقتی slug عوض میشه
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [activeSlug]);

  // ===== Not Found =====
  if (!detail) {
    return (
      <div ref={revealRoot} className={`health-sub ${isRTL ? "rtl-mode" : "ltr-mode"}`}>
        <Navbar />
        <div className="health-sub__not-found">
          <div className="health-sub__not-found-icon">
            <svg width="48" height="48" viewBox="0 0 24 24" fill="none">
              <circle
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                strokeWidth="1.5"
              />
              <path
                d="M8 8L16 16M16 8L8 16"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
              />
            </svg>
          </div>
          <h2>{translate("service.notFound") || "Service Not Found"}</h2>
          <p>
            {translate("service.notFoundDesc") ||
              "The service you're looking for doesn't exist."}
          </p>
          <button onClick={() => navigate("/services/healthcare")}>
            {translate("service.backToHealth") || "Back to Healthcare Services"}
          </button>
        </div>
        <Footer />
      </div>
    );
  }

  // ===== Flags =====
  const hasIntroExtended = !!detail.introExtended;
  const hasServicesList =
    !!detail.servicesList && detail.servicesList.length > 0;
  const hasDividerImage = detail.dividerImage !== undefined;
  const hasDepartments = !!detail.departments && detail.departments.length > 0;
  const hasSections = !!detail.sections && detail.sections.length > 0;
  const hasStats = !!detail.stats && detail.stats.length > 0;

  // ← دکمه بازگشت: اگه تو دپارتمان هستیم، برگرد به subService. وگرنه برگرد به healthcare
  const backPath = deptSlug
    ? `/services/healthcare/${subServiceSlug}`
    : "/services/healthcare";
  const backLabel = deptSlug
    ? translate(serviceDetailData[subServiceSlug]?.titleKey) ||
      serviceDetailData[subServiceSlug]?.title ||
      "Back"
    : translate("service.backToHealth") || "Back to Healthcare Services";

  return (
    <div ref={revealRoot} className={`health-sub ${isRTL ? "rtl-mode" : "ltr-mode"}`}>
      <Navbar />

      {/* ===== Hero ===== */}
      <div className="health-sub__hero">
        <div className="health-sub__hero-image-wrapper">
          <img
            src={detail.heroImage || Image1}
            alt={translate(detail.titleKey) || detail.title}
            className="health-sub__hero-image"
          />
          <div className="health-sub__hero-overlay" />
        </div>
        <div className="health-sub__hero-content">
          <h1 className="health-sub__hero-title">
            {translate(detail.titleKey) || detail.title}
          </h1>
          <div className="health-sub__hero-line" />
        </div>
      </div>

      {/* ===== Main Content ===== */}
      <div className="health-sub__container">
        {/* ===== Description ===== */}
        <div className="health-sub__intro">
          <p className="health-sub__intro-text" style={{ whiteSpace: "pre-line" }}>
            {translate(detail.descriptionKey) || detail.description}
          </p>

          {/* ===== Intro Extended ===== */}
          {hasIntroExtended && (
            <div className="health-sub__intro-extended">
              {(translate(detail.introExtendedKey) || detail.introExtended)
                .split("\n")
                .filter((p) => p.trim() !== "")
                .map((paragraph, i) => (
                  <p key={i} className="health-sub__intro-text">
                    {paragraph}
                  </p>
                ))}
            </div>
          )}
        </div>

        {/* ===== Services List ===== */}
        {hasServicesList && (
          <div className="health-sub__services-list">
            <h3 className="health-sub__services-list-title">
              {translate(
                "services.health.sub.architecture.servicesListTitle",
              ) || "Specialized Services Offered"}
            </h3>
            <ul className="health-sub__services-list-items">
              {detail.servicesList.map((item, idx) => (
                <li key={idx} className="health-sub__services-list-item">
                  {translate(item.titleKey) || item.title}
                </li>
              ))}
            </ul>
          </div>
        )}

        {/* ===== Divider Image ===== */}
        {hasDividerImage && (
          <div className="health-sub__divider">
            {detail.dividerImage ? (
              <img
                src={detail.dividerImage}
                alt="divider"
                className="health-sub__divider-img"
              />
            ) : (
              <div className="health-sub__divider-placeholder">
                <svg width="48" height="48" viewBox="0 0 24 24" fill="none">
                  <rect
                    x="3"
                    y="3"
                    width="18"
                    height="18"
                    rx="2"
                    stroke="currentColor"
                    strokeWidth="1.5"
                  />
                  <circle
                    cx="8.5"
                    cy="8.5"
                    r="1.5"
                    stroke="currentColor"
                    strokeWidth="1.5"
                  />
                  <path
                    d="M21 15l-5-5L5 21"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                <span>
                  {translate("common.imagePlaceholder") || "Image coming soon"}
                </span>
              </div>
            )}
          </div>
        )}

        {/* ===== Departments Grid (5 لینک‌دار) ===== */}
        {hasDepartments && (
          <div className="health-sub__departments">
            <div className="health-sub__departments-grid">
              {detail.departments.map((dept, idx) => (
                <div
                  key={idx}
                  className="health-sub__dept-card"
                  onClick={() =>
                    navigate(`/services/healthcare/${subServiceSlug}/${dept.slug}`)
                  }
                  role="button"
                  tabIndex={0}
                  onKeyDown={(e) =>
                    e.key === "Enter" &&
                    navigate(`/services/healthcare/${subServiceSlug}/${dept.slug}`)
                  }
                >
                  <div className="health-sub__dept-card-img">
                    {dept.image ? (
                      <img
                        src={dept.image}
                        alt={translate(dept.titleKey) || dept.title}
                      />
                    ) : (
                      <div className="health-sub__dept-card-placeholder">
                        <svg
                          width="48"
                          height="48"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <rect
                            x="3"
                            y="3"
                            width="18"
                            height="18"
                            rx="2"
                            stroke="currentColor"
                            strokeWidth="1.5"
                          />
                          <circle
                            cx="8.5"
                            cy="8.5"
                            r="1.5"
                            stroke="currentColor"
                            strokeWidth="1.5"
                          />
                          <path
                            d="M21 15l-5-5L5 21"
                            stroke="currentColor"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </div>
                    )}
                  </div>
                  <div className="health-sub__dept-card-info">
                    <h4>{translate(dept.titleKey) || dept.title}</h4>
                    <svg
                      className="health-sub__dept-card-arrow"
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <path
                        d={
                          isRTL
                            ? "M19 12H5M5 12L11 18M5 12L11 6"
                            : "M5 12H19M19 12L13 18M19 12L13 6"
                        }
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* ===== Regular Sections ===== */}
        {hasSections && (
          <div className="health-sub__sections">
            {detail.sections.map((section, index) => (
              <div key={index} className="health-sub__section">
                <div className="health-sub__section-number">
                  {String(index + 1).padStart(2, "0")}
                </div>
                <div className="health-sub__section-content">
                  <h2 className="health-sub__section-title">
                    {translate(section.titleKey) || section.title}
                  </h2>
                  <div className="health-sub__section-divider" />
                  <p className="health-sub__section-text">
                    {(translate(section.contentKey) || section.content)
                      .split("\n")
                      .map((line, i) => (
                        <React.Fragment key={i}>
                          {line}
                          {i <
                            (
                              translate(section.contentKey) || section.content
                            ).split("\n").length -
                              1 && <br />}
                        </React.Fragment>
                      ))}
                  </p>
                </div>
              </div>
            ))}
          </div>
        )}

        {/* ===== Stats ===== */}
        {activeSlug === 'healthcare-interior-design' && <section>
          <h2 className="health-sub__section-title">{isRTL ? 'پروژه‌ها' : 'Projects'}</h2>
          <ServiceProjects ids={['yon-therapy','mom','haft-e-tir','parsian-saadat-abad','chamran']} />
        </section>}
        {hasStats && (
          <div className="health-sub__stats">
            {detail.stats.map((stat, i) => (
              <div key={i} className="health-sub__stat">
                <span className="health-sub__stat-value">{stat.value}</span>
                <span className="health-sub__stat-label">
                  {translate(stat.labelKey) || stat.label}
                </span>
              </div>
            ))}
          </div>
        )}

        {/* ===== Footer Actions ===== */}
        <div className="health-sub__footer-actions">
          <button
            className="health-sub__back-btn"
            onClick={() => navigate(backPath)}
          >
            <span>
              {deptSlug ? (isRTL ? `بازگشت به ${backLabel}` : `Back to ${backLabel}`) : backLabel}
            </span>
          </button>
          <button
            className="health-sub__contact-btn"
            onClick={() => navigate("/contact-us")}
          >
            <span>{translate("service.contactUs") || "Get in Touch"}</span>
          </button>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default HealthSubService;
